import type { FaireProductEntity } from "../../entity_types/product";

export const p_kzf4azpurn: FaireProductEntity = {
  token: "p_kzf4azpurn",
  type: "product",
  name: "Bug & Tick Repellent Spray | Citronella & Cedarwood | 40ml",
  brandToken: "b_hhg6www3ax",
  brandName: "Luna Naturals",
  imageUrl:
    "https://cdn.faire.com/fastly/2b2e05776a1c89ef7a91095e1b75007b0f2866c8f3cf6023804d809d968ce70f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/be68c542c5e94e5d51dc8ed81882751ad4764344905c880444e773f79263bb7c.png",
    "https://cdn.faire.com/fastly/976c099e563636f06566d5e579180c1c46009adddb6ba55222a4d7d58e4788ba.png",
    "https://cdn.faire.com/fastly/db08178284ebdbae5545ac876a8f3d9e665c19c5801c1336f131d3df342c3560.png",
    "https://cdn.faire.com/fastly/898487f58c36a0e74da4963a77e93d18d11553d5096c0bcb488b5619f3b4cb62.png",
  ],
  priceDollars: 4,
  description:
    "Keep bugs and ticks away naturally with Luna Naturals Bug & Tick Repellent Spray! Powered by Citronella and Cedarwood oil, this DEET-free formula provides long-lasting protection against mosquitoes, ticks, and other biting insects. \n\nSafe for the whole family, it’s the perfect choice for outdoor spring and summer adventures, from easter egg hunts, picnic dates, camping and hiking to backyard BBQs.\n\n• Plant-Based Protection – Made with natural lemon & eucalyptus oil, proven to repel mosquitoes and ticks.\n• DEET-Free & Non-Toxic – Gentle on skin while effectively keeping insects at bay.\n• Long-Lasting Defense – Provides up to 6 hours of protection per application.\n• Lightweight & Non-Greasy – Absorbs quickly without leaving a sticky or oily residue.\n• Safe for the Whole Family – Suitable for adults, kids, and even pets when used as directed.\n• Perfect for Outdoor Use – Ideal for camping, hiking, fishing, picnics, and travel.",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:04.104Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
